import classNames from 'classnames';
import type { ReactNode } from 'react';

import styles from './List.module.scss';

interface Props {
    children?: ReactNode;
    className?: string;
    id?: string;
    triggerId?: string;
}

export function List({ children, className, id, triggerId }: Props) {
    return (
        <div
            aria-labelledby={triggerId}
            className={classNames(styles.list, className)}
            id={id}
            role="menu"
        >
            {children}
        </div>
    );
}
